<template>
  <div :class="['footer', { 'is-mobile': isMobile, 'is-huge': isHuge, 'is-logged-out': isLoggedOut }]">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { isHuge, isMobile } from '@/core/helpers/ui.helper';
import { useAuthStore } from '@/stores/auth.store';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const authStore = useAuthStore();
const { user } = storeToRefs(authStore);

const isLoggedOut = computed(() => {
  return !user.value?.id;
});
</script>

<style lang="scss" scoped>
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 5px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-md);
  z-index: 699;
  background: linear-gradient(to top, var(--color-dark-700) 0%, transparent 100%);
  overflow: hidden;
  pointer-events: none;

  padding: var(--spacing-xl) calc(var(--spacing-xl)) var(--spacing-xxl) var(--spacing-xl);

  & > * {
    pointer-events: auto;
  }

  &.is-huge {
    padding-left: calc(var(--spacing-xxl) + 24px);
    padding-right: calc(var(--spacing-xxl) + 24px);
  }

  &.is-mobile {
    bottom: 0;
    padding: 0 2.25rem var(--spacing-l) 2.25rem;
  }

  &.is-mobile.is-logged-out {
    padding-bottom: calc(var(--spacing-l) + 30px);
  }
}
</style>

<style lang="scss">
.gam-button.is-huge {
  .gam-button-container.create-gambit-button,
  .gam-button-container.create-club-button {
    padding-left: var(--spacing-xxl) !important;
    padding-right: var(--spacing-xxl) !important;
  }
}

.gam-button-container.location-button {
  padding-left: 36px;

  .icon-left {
    left: 12px;
  }
}
</style>
